// -----------------------------------------------------------------------------
// API Endpoint Configuration
// -----------------------------------------------------------------------------
export const API_ENDPOINT_HEADER = 'X-API-Endpoint';

export const ENDPOINT_MAP: Record<string, string> = {
  'auth:register': '/register',
  'auth:login': '/login',
  'auth:admin-login': '/restricted-access/authenticate',
  'auth:logout': '/logout/:id',
  'auth:refresh-token': '/refresh-token',
  'auth:2fa-setup': '/2fa/setup',
  'auth:2fa-enable': '/2fa/enable',
  'auth:2fa-verify': '/2fa/verify',
  'auth:2fa-disable': '/2fa/disable'
};

export const SENSITIVE_ENDPOINTS: Record<string, boolean> = {
  'auth:2fa-setup': true,
  'auth:2fa-enable': true,
  'auth:2fa-disable': true,
  'auth:2fa-verify': true,
  'auth:admin-login': true,
  'auth:refresh-token': true
};

export const PARAM_MAPPING: Record<string, string[]> = {
  'auth:logout': ['id']
};

export const PUBLIC_PATHS = ['/login', '/register'];
export const PUBLIC_ENDPOINTS = ['auth:login', 'auth:register'];
